import React  from 'react'

import {FieldTListGroupHeader1Props} from "../../../render/list/group-1"

export default function FieldDepartment_TListGroupHeader1(props: FieldTListGroupHeader1Props) {
    const value = props.field.getViewValue(props.model)
    const item = props.field._getOption(value)

    const classes = Classes("text ui5-txt-default", {
        ['gd-c-font-{0}'.f(item.color)]: !_.isNil(item?.color)
    })

    return (
        <div className={classes}>
            {item ? item.label : "Not selected"}
        </div>
    )
}